/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ResourceQueryTagKeyKind extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("ResourceQueryTagKeyKind");
    }

    getFixupPrototypeFunction() { return ResourceQueryTagKeyKind.fixupPrototype; }

    static newInstance(model: Partial<ResourceQueryTagKeyKind>): ResourceQueryTagKeyKind {
        let obj = Object.assign(new ResourceQueryTagKeyKind(), model);
        ResourceQueryTagKeyKind.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ResourceQueryTagKeyKind>): ResourceQueryTagKeyKind {
        if (!model) return null;
        return ResourceQueryTagKeyKind.newInstance(<ResourceQueryTagKeyKind> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ResourceQueryTagKeyKind) {
        if (!obj) return;

        models.ResourceQueryTagKeyKind.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ResourceQueryTagKeyKind): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ResourceQueryTagKeyKind.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Tag key for the given resources
     */
    tag_key: string;

    /**
     * Tag kind for the given key; empty or omitted means kind-less (e.g. AI platform tags)
     */
    tag_kind: string;

}
